import { RiskMeterDto } from "../../dtos/RiskMeterDto";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export const getRiskMeterData = async (grantId: string): Promise<ApiResult<RiskMeterDto> | null> => {
    return apiWrapperWithError<RiskMeterDto>(`api/riskmeter/${grantId}`, 'GET', `fetching risk meter data for grant ${grantId}`);
}
